export const SET_SETTINGS = 'SET_SETTINGS'
export const SET_USER = 'SET_USER'



// WEBPACK FOOTER //
// ./src/mut-types.js